import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useSKUOptions } from "hooks/useQueryHook";
import { useState, useEffect } from "react";
import { SelectFields } from "ui-components/Form";
import { Fieldset,Texts, DatePickerField } from "ui-components/Form";
import {
  InboundSubmitButton,
} from "ui-components/Form";
import { useZoneOptionsQuery } from "hooks/useZoneQuery";
import { useLocationOptionsQuery } from "hooks/useLocationQuery";
import { getWarehouseList } from "services/data.internal.service";
import Box from "@mui/material/Box";
import {
  insertnewCCountList,
} from "services/data.inventory.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Success, Error_ ,ExportDialog } from "ui-components/Alert";
import { useForm } from "react-hook-form";

function AddCycleCountDialog({
    open,
    onClose,
    onSave,
    customerCode,
    zoneID,
    cCountNo,
    setAlert
}) {

    const [skuOptions, setSKUOptions] = useState([]);
    const [selectedSku, setSelectedSku] = useState("");
    const [zoneOptions, setZoneOptions] = useState([]);
  const [locOptions, setLocOptions] = useState([]);
  const [recvWh, setWarehouseData] = useState("");
  const [selectedZone, setSelectedZone] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const onError = (error, setAlert) => {
    setAlert(null); // Clear any existing alert
    setAlert(<Error_ data={error} onChange={setAlert} />);
  };
  const [list, setList] = useState([]);
  const [cartonID, setCartonID] = useState("");
const [countQty, setCountQty] = useState("");
const [mln, setMln] = useState("");
//const [expiryDate, setExpiryDate] = useState("");
const queryClient = useQueryClient();
  const onSuccess = (data, setAlert) => {
    setAlert(null); // Clear any existing alert
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const { control, watch, setValue: setFormValue } = useForm({
  defaultValues: { expiryDate: null },
});
const expiryDate = watch("expiryDate");
//   useQuery({
//     queryKey: ["warehouse-list", {customerCode}],
//     queryFn: () => getWarehouseList({customerCode}),
//     // onSuccess: (data) => {
//     // //     console.log(data,"warehousecode");
//     // //         console.log(data.data.data);
//     // // console.log(data.data.data[0]);
//     // //  console.log(data.data.data[0].warehouseCode);
//     //     setWarehouseData(data.data.data[0].warehouseCode)
//     // },
//     enabled:Boolean(customerCode),
//     //onError,
//   })
//   recvWh =
//     warehouseData?.data?.data?.[0]?.warehouseCode ?? "";

  const { data: warehouseData } = useQuery({
    queryKey: ["warehouse-list", customerCode],
    queryFn: () => getWarehouseList({ customerCode }),
    enabled: Boolean(customerCode),
      onSuccess: (data) => {
          console.log(data,"warehousecode");
              console.log(data.data.data);
      console.log(data.data.data[0]);
       console.log(data.data.data[0].warehouseCode);
         setWarehouseData(data.data.data[0].warehouseCode)
     },
    // onSuccess: (response) => {
    // const warehouseCode = response.data.data?.warehouseCod
    // console.log("Warehouse:", warehouseCode
    // setWarehouseData(warehouseCode);
    // }
})
  const warehouseCode =
    warehouseData?.data?.data?.[0]?.warehouseCode ?? "";
//const recvwh = warehouseData?.data.data.data[0].warehouseCode;
// console.log(warehouseCode,"warehousecode directly from retrieve query");

    useSKUOptions({
    customerCode,
    onSuccess: (data) => {
      setSKUOptions(
        data.data.data.map((x) => ({
          label: x.skuCode,
          value: x.skuCode,
          description: x.descriptions1,
          unitPrice: x.costPrice,
          currencyCode: x.currencyCode,
        }))
      );
    },
  });

  useZoneOptionsQuery({
    enabled: Boolean(recvWh),
    whCode: recvWh,
    zoneType: "Storage/Quarantine/Return/Scrap/Staging",
    onSuccess: (data) => {
        setZoneOptions(data.data.data)

    }
  });
  useLocationOptionsQuery({
    enabled: Boolean(selectedZone),
    whCode: recvWh,
    zoneID: selectedZone,
    //onSuccess: (data) => setLocOptions(data.data.data),
    onSuccess: (data) => {
        console.log("enteringlocationoption");
        setLocOptions(data.data.data)
    }
  });

//   const skuDropdownOptions = skuOptions.map(item => ({
//     value: item.skuCode,
//     label: item.skuCode,
// }));
    const updateFinalCountListMutation = useMutation(insertnewCCountList, {
        onSuccess: (data) => {
            console.log("added successfully");
            console.log(list,"listfromfinalsuccess");
          queryClient.invalidateQueries(["cycopnbalscan-details"]);
          setAlert(
            <Success
                 data={data}
                onChange={setAlert}
            />
        );
          //onSuccess("Row added successfully");
          //setAlert(<Success data={list} onChange={setAlert} />);
          //refetch();
          onClose();
          setSelectedSku(null);
    setSelectedZone("");
    setSelectedLocation("");
    setCountQty("");
    setCartonID("");
    setMln("");
    //setExpiryDate("");
    setFormValue("expiryDate", null);
        },
        onError,
      });

    const onSubmit = () => {
        console.log("enteronsubmit");
         const newRow = {
    skuCode: selectedSku?.value,
    zoneID: selectedZone,
    locationID: selectedLocation,
    countQty: countQty,
    cartonID: cartonID,
    mln: mln,
    expiryDate: expiryDate,
  };
  
   setList([newRow]);
   //setList(prev => [...prev, newRow]);
  console.log(list,"list");
  //setOpen(false);
         const validatedList2 = list.map((item) => ({
    skuCode: item.skuCode,
    locationID: item.locationID,
    zoneID: item.zoneID,
    countQty: item.countQty,
    cartonID: item.cartonID,
    mlN: item.mlN,
    expiryDate: item.expiryDate,
  }));
    //     const validatedList = list.map((item) => ({
    //       ...item,
    //        customer: selectedCustomer,
    // pCountNo: pCountNo
    //       //vendorCode: item.vendorCode?.value || item.vendorCode,
    //     }));
        console.log("validatedlist", validatedList2);
        const payload = {
  customer: customerCode,
  cCountNo: cCountNo,
  items: newRow
};
const validatedList3 = [{
    skuCode: selectedSku?.value,
    zoneID: selectedZone,
    locationID: selectedLocation,
    countQty: countQty,
    cartonID: cartonID,
    mln: mln,
    expiryDate: expiryDate,
    customer: customerCode,
    cCountNo: cCountNo,
}];
console.log(validatedList3,"validatedList3");

updateFinalCountListMutation.mutate({
    CCountNo : cCountNo,
    Customer: customerCode,
    Items: validatedList3,
});
        //updateFinalCountListMutation.mutate(payload);
      };

  useEffect(() => {
    console.log("recvWh changed:", recvWh);
}, [recvWh]);
useEffect(() => {
    console.log("selectedZone changed:", selectedZone);
}, [selectedZone]);


    // const { data: skuList = [] } = useQuery({
    //     queryKey: ["skuList", customerCode],
    //     queryFn: () =>
    //         getSKUList({
    //             customerCode,
    //         }),
    //     enabled: open,
    // });

    // const { data: locationList = [] } = useQuery({
    //     queryKey: ["locationList", customerCode, zoneID],
    //     queryFn: () =>
    //         getLocationList({
    //             customerCode,
    //             zoneID,
    //         }),
    //     enabled: open,
    // });

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>Add New Item</DialogTitle>
            <DialogContent>
                <Box sx={{ pt: 1 }}>
            <SelectFields
             field={{
                  name: "zoneid",
                  label: "Zone ID",
                  value: selectedZone,
                  errors: {},
                }}
                options={zoneOptions} onChange={(event, value) => {
    setSelectedZone(value);
}}
            />
            </Box>
            <Box sx={{ pt: 1 }}>
            <SelectFields  
             field={{
                  name: "locationid",
                  label: "Location ID",
                  value: selectedLocation,
                  errors: {},
                }}
                options={locOptions} 
                onChange={(event, value) => {
    setSelectedLocation(value);
}}
            />
            </Box>
            <Box sx={{ pt: 1 }}>
            <Texts
            field={{ name: "cartonID", label: "Carton ID", maxLength: 20 }}
            onChange={(e) => setCartonID(e.target.value)}
            //onChange={({ target }) => (doRef.current = target.value)}
          />
</Box>
<Box sx={{ pt: 2 }}>
            <SelectFields  
             field={{
                  name: "skucode",
                  label: "SKU Code",
                  value: selectedSku,
                  errors: {},
                }}
                options={skuOptions} //onChange={setSelectedSku} 
                onChange={(event, value) => {
    setSelectedSku(value);
}}
            />
            </Box>
            <Texts
            field={{ name: "countQty", label: "Count Qty", maxLength: 20 }}
            onChange={(e) => setCountQty(e.target.value)}
            //onChange={({ target }) => (doRef.current = target.value)}
          />
          <Box sx={{ pt: 2 }}>
          <Texts
            field={{ name: "mlN", label: "MLN", maxLength: 20 }}
            onChange={(e) => setMln(e.target.value)}
            //onChange={({ target }) => (doRef.current = target.value)}
          />
          </Box>
          <Box sx={{ pt: 2 }}>
            <DatePickerField
    field={{
      name: "expiryDate",
      label: "Expiry Date",
      control: control,
      errors: {},
    }}
  />
            {/* <Texts
            field={{ name: "expiryDate", label: "Expiry Date", maxLength: 20 }}
             onChange={(e) => setExpiryDate(e.target.value)}
            //onChange={({ target }) => (doRef.current = target.value)}
          /> */}
          </Box>
          </DialogContent>
          <DialogActions>

        {/* <InboundSubmitButton label="Cancel"
            onClick={() => setOpenAddDialog(false)}
        >
            
        </InboundSubmitButton> */}

        <InboundSubmitButton label="Save"
        onClick={onSubmit}
            //variant="contained"
            //onClick={handleSaveRow}
        >
        </InboundSubmitButton>

    </DialogActions>
        </Dialog>
    );
}

export default AddCycleCountDialog;